import type { ContentItem } from 'src/types/content';
import { mergeClasses } from 'src/utils/merge-classes';

import { Reveal } from './reveal';

type CardGridProps = {
  items: ContentItem[];
  columns?: 2 | 3;
};

export function CardGrid({ items, columns = 3 }: CardGridProps) {
  return (
    <div className={mergeClasses(columns === 3 ? 'grid-3' : 'grid-2')}>
      {items.map((item) => (
        <Reveal key={item.title} className="card">
          <h3>{item.title}</h3>
          <p>{item.text}</p>
        </Reveal>
      ))}
    </div>
  );
}
